export const setAuth = "setAuth";
export const setLock = "setLock";
export const getToken = "getToken";
export const getUser = "getUser";
export const getRole = "getRole";
